export default function ControlButton({ mode, onStart, onReset }) {
  const start = mode === "start";
  return (
    <button
      type="button"
      className={`control-btn ${start ? "control-start" : "control-reset"}`}
      data-testid={start ? "start-experiment-button" : "reset-button"}
      onClick={start ? onStart : onReset}
    >
      {start ? "START EXPERIMENT" : "RESET"}
    </button>
  );
}
